import React from "react";
import { TextField, InputAdornment } from "@material-ui/core";
import { SearchIcon } from "../CustomIcons";

const SearchInput = ({ handleChange, className = "", style = {}, ...rest }) => {
  return (
    <TextField
      label="Search"
      className={`w-100 ${className}`}
      style={style}
      onChange={handleChange}
      // id="filled-start-adornment"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      variant="outlined"
      {...rest}
    />
  );
};

export default SearchInput;
